import { render } from "./AppleLabelGridItem.vue?vue&type=template&id=26d08c1e"
import script from "./AppleLabelGridItem.vue?vue&type=script&lang=js"
export * from "./AppleLabelGridItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__